<template>
  <div id="gis">
    <vl-map
      :load-tiles-while-animating="true"
      :load-tiles-while-interacting="true"
      @click="clickFeature"
      class="map"
      ref="map"
      data-projection="EPSG:4326"
      style="height: 700px;z-index: 1"
    >
      <vl-view
        :zoom.sync="zoom"
        :center.sync="center"
        :rotation.sync="rotation"
      ></vl-view>

      <vl-layer-tile>
        <vl-source-osm></vl-source-osm>
      </vl-layer-tile>

      <vl-layer-vector render-mode="image" :update-while-interacting="true">
        <vl-source-vector :features.sync="features"></vl-source-vector>
        <vl-style-box :condition="isYellou">
          <vl-style-stroke color="yellow" :width="4"></vl-style-stroke>
        </vl-style-box>
        <vl-style-box :condition="isBlue">
          <vl-style-stroke color="blue" :width="4"></vl-style-stroke>
        </vl-style-box>
        <vl-style-box :condition="isImpec">
          <vl-style-stroke color="orange" :width="4"></vl-style-stroke>
        </vl-style-box>
        <vl-style-box :condition="isLvd">
          <vl-style-stroke color=" #75a4ef" :width="4"></vl-style-stroke>
        </vl-style-box>
      </vl-layer-vector>
      <vl-layer-vector v-if="viewLayer.tramol">
        <vl-source-vector :features.sync="featuresLoc"></vl-source-vector>
        <vl-style-box>
          <vl-style-stroke color="#853232" :width="4"></vl-style-stroke>
        </vl-style-box>
      </vl-layer-vector>

      <vl-layer-vector
        render-mode="image"
        :update-while-interacting="true"
        v-if="viewLayer.flujo"
      >
        <vl-source-vector :features.sync="flujos"></vl-source-vector>
        <vl-style-box>
          <vl-style-stroke color="red" :width="2"></vl-style-stroke>
          <vl-style-fill color="red"></vl-style-fill>
        </vl-style-box>
      </vl-layer-vector>

      <vl-layer-vector
        render-mode="image"
        :update-while-interacting="true"
        v-if="viewLayer.camara"
      >
        <vl-source-vector :features.sync="camaras"></vl-source-vector>
        <vl-style-box>
          <vl-style-circle :radius="6">
            <vl-style-stroke color="#0c0a0a" :width="4"></vl-style-stroke>
            <vl-style-fill color="white"></vl-style-fill>
          </vl-style-circle>
        </vl-style-box>
      </vl-layer-vector>

      <vl-layer-vector render-mode="image" :update-while-interacting="true">
        <vl-source-vector :features.sync="selectedFeatures"></vl-source-vector>
        <vl-style-box>
          <vl-style-stroke color="#8dff02" :width="7"></vl-style-stroke>
        </vl-style-box>
      </vl-layer-vector>
      <!--gg
      <vl-layer-vector>
        <vl-source-vector url="http://localhost:4000/api/Documentos/Descarga/time.kml" :format-factory="kmlFormatFactory"></vl-source-vector>
      </vl-layer-vector>-->
      <vl-feature v-if="punto!=null" id="position-feature">
        <vl-geom-point :coordinates="punto"></vl-geom-point>
        <vl-style-box>
          <vl-style-icon
            src="http://s3-ap-southeast-1.amazonaws.com/seeoutlook/wp-content/uploads/2018/05/17113436/Location.png"
            :scale="0.1" :anchor="[0.5, 1]"></vl-style-icon>
        </vl-style-box>
      </vl-feature>
      <vl-overlay
        class="feature-popup"
        v-for="feature in selectedInf"
        :key="feature.id"
        :id="feature.id"
        :position="pointOnSurface(feature.geometry)"
        :auto-pan="true"
        :auto-pan-animation="{ duration: 300 }"
        v-if="selectedInf.length > 0"
      >
        <template slot-scope="scope">
          <div class="overlay-content">
            <div
              class="popover bs-popover-bottom bs-popover-bottom-docs"
              style="width: 200px;"
            >
              <div class="arrow" style="left: 6px"></div>
              <h3 class="popover-header" style="margin-top: -1px">
                <strong>Capa</strong> tipo:{{ feature.geometry.type
                }}<a
                class="float-right"
                title="Close"
                @click="cerrarDetalle(feature.id)"
              >
                <span class="ti-close"></span>
              </a>
              </h3>
              <div class="popover-body">
                <p>
                  Subcuenca: {{ feature.properties.IDSV }}
                  {{
                  feature.properties.IDENTIFICA != null
                  ? "Identifica:" + feature.properties.IDENTIFICA
                  : ""
                  }}
                  {{
                  feature.properties.IDFLUJO != null
                  ? "ID_Flujo:" + feature.properties.IDFLUJO
                  : ""
                  }}
                  {{
                  feature.properties.SHAPE_Leng != null
                  ? "L_Shape:" + Math.trunc(feature.properties.SHAPE_Leng)
                  : ""
                  }}
                </p>
              </div>
            </div>
          </div>
        </template>
      </vl-overlay>
      <vl-overlay class="feature-popup" v-if="carga" :position="center">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </vl-overlay>

    </vl-map>
    <transition name="slide-fade">
      <div
        class="float-right botonmapa"
        :style="
          openbtn ? 'width: 350px' : 'width: 40px;margin-right:5px!important;'
        "
      >
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              block
              @click="openbtn = !openbtn"
              v-b-toggle.accordion-1
              variant="info"
            ><span
              :class="openbtn ? 'ti-angle-double-up' : 'ti-angle-double-left'"
            ></span
            ></b-button>
          </b-card-header>
          <b-collapse
            id="accordion-1"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <!-- <b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text>-->
              <div>
                <div no-body>
                  <b-form-group style="margin-left: 100px" label="Herramientas">
                    <table>
                      <tr>
                        <th>
                          <b-form-radio
                            v-model="tools"
                            name="radio-inline"
                            value="A"
                          ><span class="ti-pencil"></span
                          ></b-form-radio>
                        </th>
                        <th>
                          <b-form-radio
                            v-model="tools"
                            name="radio-inline"
                            value="B"
                          ><span class="ti-info-alt"></span
                          ></b-form-radio>
                        </th>
                      </tr>
                    </table>
                  </b-form-group>
                  <b-tabs v-model="tabindex" card>
                    <b-tab title="Informacion" active>
                      <table class="table is-fullwidth">
                        <tr>
                          <th>Map center</th>
                          <td>{{ center }}</td>
                        </tr>
                        <tr>
                          <th>Map zoom</th>
                          <td>{{ zoom }}</td>
                        </tr>
                        <tr>
                          <th>Map rotation</th>
                          <td>{{ rotation }}</td>
                        </tr>
                        <tr>
                          <th>Selected features</th>
                          <td>{{ selectedFeatures.map(f => f.id) }}</td>
                        </tr>
                        <tr>
                          <td>
                            <b-button
                              size="sm"
                              @click="imagerySet = 'AerialWithLabels'"
                            >Satelital
                            </b-button
                            >
                          </td>
                          <td>
                            <b-button
                              size="sm"
                              @click="imagerySet = 'CanvasGray'"
                            >Calles
                            </b-button
                            >
                          </td>
                        </tr>
                      </table>
                    </b-tab>

                    <b-tab title="Busqueda">
                      <b-row class="my-1">
                        <b-col sm="2">
                          <label for="input-default1">SC</label>
                        </b-col>
                        <b-col sm="10">
                          <b-form-input
                            @keyup.enter="buscarSC"
                            type="number"
                            id="input-default1"
                            v-model="subcuenca"
                            placeholder="Busqueda por SC"
                            trim
                          ></b-form-input>
                        </b-col>
                      </b-row>
                      <b-row class="my-1">
                        <b-col sm="2">
                          <label for="input-default2">Tramo</label>
                        </b-col>
                        <b-col sm="10">
                          <b-form-input
                            @keyup.enter="buscarTr"
                            type="number"
                            id="input-default2"
                            v-model="tramo"
                            placeholder="Busqueda por Tramos"
                            trim
                          ></b-form-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="2">
                          <label for="drec">Direcc</label>
                        </b-col>
                        <b-col sm="10">
                          <b-form-input
                            @keyup.enter="buscarDirec"
                            id="drec"
                            v-model="direccion"
                            placeholder="Busqueda por Direccion"
                          ></b-form-input>
                        </b-col>
                      </b-row>
                      <b-row class="my-1">
                        <b-col sm="10">
                          <b-form-checkbox
                            :disabled="enable"
                            v-model="switchl"
                            name="check-button"
                            switch
                          >
                            Localidad
                          </b-form-checkbox>
                        </b-col>
                        <b-col sm="10">
                          <b-form-checkbox
                            v-model="viewLayer.camara"
                            name="check-button"
                            switch
                          >
                            <span class="ti-eye"></span> Ver camaras
                          </b-form-checkbox>
                        </b-col>
                        <b-col sm="10">
                          <b-form-checkbox
                            v-model="viewLayer.tramol"
                            name="check-button"
                            switch
                          >
                            <span class="ti-eye"></span> Ver localidad
                          </b-form-checkbox>
                        </b-col>
                      </b-row>
                    </b-tab>
                    <b-tab
                      title="Ingreso"
                      :disabled="Settramo == null"
                      style="max-height: 600px;overflow-x: scroll;"
                    >
                      <form-predata
                        v-if="Settramo != null"
                        :tramo="Settramo.properties.IDENTIFICA"
                        :subcuenca="Settramo.properties.IDSV"
                        :shape_leng="Settramo.properties.SHAPE_Leng"
                        :state="Settramo.properties.state"
                      >
                      </form-predata>
                    </b-tab>
                    <b-tab title="Dibujar">
                      {{tabindex}}
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </transition>
    <shp-json v-if="features.length>0" :tramos="features"></shp-json>
    <!--
   <div class="row">

     <div class="col-12">
       <input type="file" @change="uploadFieldChange" />
       <div class="row">
         <div class="col-6">
         </div>
         <div class="col-6"></div>
       </div>
     </div>
   </div>
   <import-geojson></import-geojson>-->
  </div>
</template>

<script>
    /* eslint-disable no-console */
    import Http from "../Http";
    import {findPointOnSurface} from "vuelayers/lib/ol-ext";
    import ImportGeojson from "./importGeojson";
    import FormSupInforme from "./form-supInforme";
    import Eventbus from "../Bus";
    import FormPredata from "./formPredata";
    import EventBus from "../Bus";
    import axios from "axios";
    import ShpJson from "./shp-json";
    import KML from 'ol/format/KML';
    // eslint-disable-next-line no-undef
    const shapefile = require("shapefile");
    export default {
        name: "MapsGis",
        components: {ShpJson, FormPredata, FormSupInforme, ImportGeojson},
        watch: {
            features() {
                if (this.features.length > 0) {
                    this.enable = false;
                }
            },
            switchl() {
                if (this.features.length > 0 && this.switchl) {
                    this.carga = true;
                    this.getLocalidad();
                }
            }
        },
        methods: {
            kmlFormatFactory() {
                return new KML();
            },
            getLocalidad() {
                let tmp = this.features[0];
                Http.Http()
                    .get(
                        `Map/bylocalidad/${tmp.properties.IDENTIFICA}/${tmp.properties.IDSV}`
                    )
                    .then(res => {
                        // this.loadtoMap(res.data);
                        let tmptramo = [],
                            tmpflujo = [],
                            tmpcamara = [];
                        res.data.forEach(x => {
                            tmptramo = tmptramo.concat(
                                x.tramos.map(y => JSON.parse(y.datajson))
                            );
                            tmpflujo = tmpflujo.concat(JSON.parse(x.flujos));
                            tmpcamara = tmpcamara.concat(
                                x.camaras.map(y => JSON.parse(y.datajson))
                            );
                        });
                        this.featuresLoc = tmptramo;
                        this.camaras = this.camaras.concat(tmpcamara);
                        this.flujos = this.flujos.concat(tmpflujo);
                        console.log(this.featuresLoc.length);
                        setTimeout(() => {
                            this.carga = false;
                        }, this.featuresLoc.length);
                    })
                    .catch(err => alert(err));
            },
            loadtoMap(tmp) {
                let x = tmp.shift();
                if (x != null) {
                    this.featuresLoc = this.featuresLoc.concat(
                        x.tramos.map(y => JSON.parse(y.datajson))
                    );
                    this.camaras = this.camaras.concat(
                        x.camaras.map(y => JSON.parse(y.datajson))
                    );
                    this.flujos = this.flujos.concat(JSON.parse(x.flujos));
                    setTimeout(() => {
                        this.loadtoMap(tmp);
                    }, 100);
                } else this.carga = false;
            },
            shptest() {
                console.log("en el metodp");
                //:features.sync="features"
                let data = this;
                shapefile
                    .open(
                        "https://raw.githubusercontent.com/matplotlib/basemap/v1.1.0/lib/mpl_toolkits/basemap/data/UScounties.shp"
                    )
                    .then(source =>
                        source.read().then(function log(result) {
                            if (result.done) return;
                            console.log(result.value);
                            data.features.push(result.value);
                            return source.read().then(log);
                        })
                    )
                    .catch(error => console.error(error.stack));
            },
            uploadFieldChange(e) {
                let file = e.target.files || e.dataTransfer.files;
                console.log(file[0]);
                let lector = new FileReader();
                let tmp = this;
                lector.onload = function (e) {
                    let contenido = e.target.result;
                    tmp.readdata(contenido);
                };
                lector.readAsText(file[0]);
            },
            readdata(data) {
                let mapas = JSON.parse(data).features.map(x => ({
                    type: x.type,
                    id: x.properties.OBJECTID,
                    geometry: x.geometry,
                    properties: x.properties
                }));
                mapas = mapas.filter(x => x.properties.IDSV !== 0);
                this.upSubcuenca(mapas);
            },
            clickFeature({pixel}) {
                this.selectedFeatures = [];
                this.selectedInf = [];
                // this.Settramo = null;
                let pr = null;
                this.$refs.map.forEachFeatureAtPixel(pixel, (feature, layer) => {
                    let data;
                    console.log(layer);
                    let type = Object.keys(feature.values_).length;
                    if (type === 4) {
                        data = this.camaras.find(x => x.id === feature.id_);
                    }
                    if (type === 20) {
                        data = this.features.find(x => x.id === feature.id_);
                        if (data == null)
                            data = this.featuresLoc.find(x => x.id === feature.id_);
                    }
                    if (type === 9) {
                        data = this.flujos.find(x => x.id === feature.id_);
                    }
                    if (pr === null) {
                        pr = data;
                    }
                    console.log(pr);
                });
                if (pr != null) {
                    if (pr.geometry.type === "LineString" && this.tools === "A") {
                        if (this.Settramo != null) {
                            if (confirm("Quiere Salir Del Tramo Actual")) {
                                this.Settramo = null;
                                setTimeout(() => {
                                    this.Settramo = pr;
                                }, 300)
                            }
                        } else {
                            this.Settramo = pr;
                        }

                    }
                    if (this.tools === "B") {
                        this.selectedInf.push(pr);
                    }

                    this.selectedFeatures.push(pr);
                }
                // using vl-map component
                // or from ol.Map instance
                // let feature = this.$refs.map.$map.forEachFeatureAtPixel(...) or any other method of map
                // then find your geojson feature by id in your data
            },
            upSubcuenca(datajson) {
                if (datajson.length > 0) {
                    let IDSV = datajson[0].properties.IDSV;
                    let dt = datajson.filter(x => x.properties.IDSV === IDSV);
                    console.log(dt);
                    Http.Http()
                        .post("Map", {shape_id: IDSV, flujos: JSON.stringify(dt)})
                        .then(() => {
                            let rm = datajson.filter(x => x.properties.IDSV !== IDSV);
                            datajson = [];
                            this.upSubcuenca(rm);
                        })
                        .catch(err => console.log(err));
                }
            },
            isYellou(feature) {
                return feature.values_.state === 0;
            },
            isBlue(feature) {
                return feature.values_.state === 3;
            },
            isImpec(feature) {
                return feature.values_.state === 2;
            },
            isLvd(feature) {
                return feature.values_.state === 1;
            },
            buscarSC() {
                Http.Http()
                    .get(`Map/${this.subcuenca}`)
                    .then(resp => {
                        this.punto = null;
                        this.switchl = false;
                        this.featuresLoc = [];
                        resp.data.forEach(x => {
                            let f = x.tramos.map(y => JSON.parse(y.datajson));
                            this.flujos = JSON.parse(x.flujos);
                            this.camaras = x.camaras.map(y => JSON.parse(y.datajson));
                            this.features = f;
                            this.center = f[0].geometry.coordinates[0];
                            this.zoom = 16;
                        });
                        this.subcuenca = "";
                    })
                    .catch(err => console.log(err));
            },
            buscarTr() {
                Http.Http()
                    .get(`Map/tramo/${this.tramo}`)
                    .then(resp => {
                        this.punto = null;
                        this.switchl = false;
                        this.featuresLoc = [];
                        resp.data.forEach(x => {
                            let f = x.tramos.map(y => JSON.parse(y.datajson));
                            this.flujos = JSON.parse(x.flujos);
                            this.camaras = x.camaras.map(y => JSON.parse(y.datajson));
                            this.features = f;
                            let point = f.find(x => x.properties.IDENTIFICA == this.tramo);
                            this.center = point.geometry.coordinates[0];
                            this.selectedFeatures = [];
                            setTimeout(() => {
                                let temp = [];
                                temp.push(point);
                                this.selectedFeatures = temp;
                            }, 400);
                            this.zoom = 18;
                        });
                        this.subcuenca = "";
                        this.tramo = "";
                    })
                    .catch(err => console.log(err));
            },
            cerrarDetalle() {
                /*
                let index = this.selectedFeatures.findIndex(x => x.id === id);
                this.selectedFeatures.splice(index,1);*/
                this.selectedFeatures = [];
                this.selectedInf = [];
                this.Settramo = null;
            },
            onPost(f) {
                if (f != null) {
                    this.features.find(
                        x => x.properties.IDENTIFICA === f.id
                    ).properties.state = f.state;
                    let tmp = this.features;
                    this.features = [];
                    setTimeout(() => {
                        this.features = tmp;
                    }, 100);
                }
                this.Settramo = null;
            },
            pointOnSurface: findPointOnSurface,
            buscarDirec() {
                axios
                    .get(
                        `https://geocoder.api.here.com/6.2/geocode.json?app_id=dSZGvDkSD5EFq6o7wfUF&app_code=FxUr0-9JVF4SkWW4FLanrQ&searchtext=${
                            this.direccion.replace(" ", "+")
                        }`
                    )
                    .then(rep => {
                        let loc =
                            rep.data.Response.View[0].Result[0].Location.DisplayPosition;
                        if (loc != null) this.getshapebyCoord(loc);
                    })
                    .catch(err => console.log(err));
            },
            getshapebyCoord(loc) {
                this.switchl = false;
                Http.Http()
                    .get(`Map/GetbyCoordenadas/${loc.Latitude}/${loc.Longitude}`)
                    .then(rep => {
                        this.features = [];
                        this.camaras = [];
                        this.flujos = [];
                        rep.data.forEach(x => {
                            this.features = this.features.concat(
                                x.tramos.map(y => JSON.parse(y.datajson))
                            );
                            this.camaras = this.camaras.concat(
                                x.camaras.map(y => JSON.parse(y.datajson))
                            );
                            this.flujos = this.flujos.concat(JSON.parse(x.flujos));
                        });
                        this.center = [loc.Longitude, loc.Latitude];
                        this.punto = [loc.Longitude, loc.Latitude];
                        this.zoom = 18;
                    })
                    .catch(err => console.log(err));
            }
        },
        data() {
            return {
                viewLayer: {
                    camara: true,
                    flujo: true,
                    tramol: true
                },
                carga: false,
                featuresLoc: [],
                showCollapse: true,
                panelOpen: true,
                tramo: null,
                file: "",
                zoom: 13,
                center: [-73.060718, -36.8276694],
                rotation: 0,
                features: [],
                tools: null,
                subcuenca: "",
                selectedFeatures: [],
                selectedInf: [],
                flujos: [],
                camaras: [],
                apiKey:
                    "Ap_Nx0ZL2UOEcPwxFfuruSwXoLRGT0cVDFsY7ccWjPXA0yxagqCPyCl4DucVHHE7",
                imagerySet: "CanvasGray",
                tabindex: 0,
                Settramo: null,
                openbtn: true,
                switchl: false,
                enable: true,
                direccion: "",
                punto: null
            };
        },
        mounted() {
            Eventbus.$on("feature", f => {
                console.log("dsdsd");
                this.features.find(
                    x => x.properties.IDENTIFICA === f.id
                ).properties.state = f.state;
            });
            //this.buscarDirec();
            EventBus.$on("onPostdata", this.onPost);
        }
    };
</script>

<style scope>
  .botonmapa {
    z-index: 10;
    margin-top: -700px;
  }

  .slide-fade-enter-active {
    transition: all 0.3s ease;
  }

  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    transform: translateX(10px);
    opacity: 0;
  }
</style>
